<template>
  <div class="card mt-2 mb-2 ms-5 me-5">
    <!-- <h1>{{ $store.getters.getRawMatFamily }}</h1> -->
    <div class="card-body">
      <h4><strong>Especificaciones de la materia prima</strong></h4>
      <div class="table-responsive">
        <table class="mx-auto">
          <tbody>
            <tr>
              <td class="lblform">
                <strong>Presentación/ Norma /Acabado:</strong>
              </td>
              <td colspan="3">
                <select id="sheetSpecification" class="form-select avilable-input" v-model="sheet"
                  @change="getParameters(sheet)">
                  <option selected>Opciones disponibles...</option>
                  <option v-for="sheetAv in availableSheets" :key="sheetAv.id" v-bind:value="sheetAv">
                    {{ sheetAv }}
                  </option>
                </select>
              </td>
            </tr>
            <tr>
              <td class="lblform"><strong>Unidad de espesor:</strong></td>
              <td>
                <select id="sheetScale" class="form-select avilable-input" v-model="scale" @change="getSheetId(scale)">
                  <option selected>Opciones disponibles...</option>
                  <option v-for="scale in scales" :key="scale.id" v-bind:value="scale.sheet_id">
                    {{ scale.sheet_scale }}
                  </option>
                </select>
              </td>
              <td class="lblform"><strong>Espesor solicitado:</strong></td>
              <td>
                <select id="sheetThickness" class="form-select avilable-input" v-model="sheetTypeId"
                  @change="getInfoSheetType(sheetTypeId)">
                  <option selected>Opciones disponibles...</option>
                  <option v-for="sheetType in sheetTypes" :key="sheetType.id" v-bind:value="sheetType.id">
                    {{ sheetType.thickness }}
                  </option>
                </select>
              </td>
            </tr>
            <tr>
              <td class="lblform">
                <strong>Espesor comercial en <i>(mm)</i>:</strong>
              </td>
              <td class="inputForm">
                <input type="number" readonly class="form-control" id="sheetCommercialMm" v-model="sheetCommercialMm" />
              </td>
              <td class="lblform">
                <strong>Precio por kilo de materia prima <i>(Lámina)</i>:</strong>
              </td>
              <td class="inputForm">
                <input type="number" readonly class="form-control" id="sheetKiloPrice" v-model="sheetKiloPrice" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
  props: {
    getLength: Number,
    getWidth: Number,
  },
  watch: {
    getLength(newVal) {
      if (newVal !== null) {
        this.calculateWeight();
      }
    },
    getWidth(newVal) {
      if (newVal !== null) {
        this.calculateWeight();
      }
    },
    sheetCommercialMm() {
      this.adjustPriceByThickness();
    },
  },
  data() {
    return {
      //Nombre y id de la materia prima principal
      //Según el id de esa materia prima principal se hace una búsqueda de las láminas disponibles
      rawMatName: "",
      rawMatId: 0,
      availableSheets: [],
      //Select 1
      //Selecinar tipo lámina requerida y con los parámetros sheetPresnetation y sheetSpecification realizar búsqueda
      sheetPresentation: "",
      sheetSpecification: "",
      //En la variable sheetKiloPrice se almacena el valor del kilo según la primera lámina que coincida con los parámetros anteriores
      baseKiloPrice: 0,
      sheetKiloPrice: 0,
      //Select 2
      //Unidades de espesor disponibles spara la lamina seleccionada
      scales: [],
      sheetFinalId: 0,
      //Select 3
      sheetTypes: [],
      sheetTypeId: 0,
      //Información del tipo de lámina final seleccionada
      sheetType: [],
      //Variable según el tipo de lámina seleccionada
      sheetCommercialMm: "",
      //Variable de peso
      sheetWeight: 0,
    };
  },
  methods: {
    validateRawMatName(rawName) {
      if (rawName === "ACERO_CARBONO") {
        this.rawMatId = 1;
        return true;
      } else if (rawName === "ANTIDESGASTE") {
        this.rawMatId = 2;
        return true;
      } else if (rawName === "INOXIDABLE") {
        this.rawMatId = 3;
        return true;
      } else if (rawName === "ALUMINIO") {
        this.rawMatId = 4;
        return true;
      } else {
        this.rawMatId = 0;
        return false;
      }
    },
    getParameters(option) {
      //console.log(option);
      if (option != "") {
        const parts = option.split(" / ");
        this.sheetPresentation = parts[0].trim();
        this.sheetSpecification = parts[1].trim();
        // console.log(this.sheetPresentation);
        // console.log(this.sheetSpecification);
      } else {
        alert("Por favor, sleccione una opcion válida");
      }
      this.searchSheetsByParameters();
    },
    async searchSheetsByParameters() {
      if (this.sheetPresentation === "" || this.sheetSpecification === "") {
        console.log("Materia prima no selecionada");
      } else {
        try {
          let res = await axios.get(RUTA_SERVIDOR + "api/sheet/list", {
            params: {
              sheet_presentation: this.sheetPresentation,
              sheet_specification: this.sheetSpecification,
            },
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          });
          //console.log(res.data);
          if (!res.data) {
            console.log("There has been a different error with the data.");
          } else {
            this.baseKiloPrice = res.data[0].priceId["value"];
            //console.log(this.baseKiloPrice);
            //console.log(res.data);
            const keyValueArray = res.data.map((sheet) => ({
              sheet_id: sheet.id,
              sheet_scale: sheet.scale,
            }));
            this.scales = Array.from(keyValueArray);

          }
        } catch (err) {
          console.log(`There has been an error ${err}`);
        }
      }
    },
    getSheetId(option) {
      this.sheetFinalId = option;
      this.searchSheetsTypes();
      // console.log(this.sheetFinalId);
    },
    async searchSheetsTypes() {
      if (this.sheetFinalId == 0) {
        console.log("Materia prima no selecionada");
      } else {
        try {
          let res = await axios.get(RUTA_SERVIDOR + "api/sheet/type/list", {
            params: {
              sheet_main_id: this.sheetFinalId,
            },
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          });
          // console.log(res.data);
          if (!res.data) {
            console.log("There has been a different error with the data.");
          } else {
            // console.log(res.data);
            this.sheetTypes = res.data;
          }
        } catch (err) {
          console.log(`There has been an error ${err}`);
        }
      }
    },
    async getInfoSheetType() {
      if (this.sheetTypeId == 0) {
        console.log("Materia prima no selecionada");
      } else {
        try {
          let res = await axios.get(RUTA_SERVIDOR + "api/sheet/type/get", {
            params: {
              sheetType_id: this.sheetTypeId,
            },
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          });
          //console.log(res.data);
          this.$emit("sendSheetTypeId", this.sheetTypeId);
          if (!res.data) {
            console.log("There has been a different error with the data.");
          } else {
            //console.log(res.data);
            this.sheetType = res.data[0];
          }
        } catch (err) {
          console.log(`There has been an error ${err}`);
        }
        this.sheetCommercialMm = this.sheetType.thicknessCommercialMm;

        //Se puso aquí
        this.adjustPriceByThickness();

        this.$emit("sendPriceConstant", this.sheetType.constPrice);
        this.$emit("sendCommercialMm", this.sheetCommercialMm);
        this.calculateWeight();
      }
    },
    calculateWeight() {
      this.sheetWeight = (this.getLength / 100) * (this.getWidth / 100) * (this.sheetCommercialMm) * (this.sheetType.constWeight);
      // console.log(this.sheetWeight);
      if (!isNaN(this.sheetWeight)) {
        let roundWeight = this.roundWeight(this.sheetWeight);
        //console.log(roundWeight);
        this.$emit("sendWeight", roundWeight);
      } else {
        console.log("Sheet weight not fount or NaN");
      }
    },
    // formatWeight(number, decimals = 2, decimalSeparator = ',', thousandSeparator = '.') {
    //   if (isNaN(number)) return "";

    //   const formatedValue = number.toFixed(decimals)
    //     .replace('.', decimalSeparator)
    //     .replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);

    //   return formatedValue;
    // },
    roundWeight(numero) {
      return Math.round(numero * 10) / 10;
    },

    adjustPriceByThickness() {

      //Auxiliary variable to adjust the kilo price according to the commercial thickness.
      this.sheetKiloPrice = this.baseKiloPrice;

      if (this.sheetCommercialMm >= 12 && this.sheetCommercialMm <= 25) {
        this.sheetKiloPrice += 200;
      } else if (this.sheetCommercialMm > 25 && this.sheetCommercialMm <= 50) {
        this.sheetKiloPrice += 500;
      } else if (this.sheetCommercialMm > 50 && this.sheetCommercialMm <= 100) {
        this.sheetKiloPrice += 900;
      } else {
        this.sheetKiloPrice;
      }
      //The price per kilo is issued to another component of the view or parent component
      this.$emit("sendKiloPrice", this.sheetKiloPrice);
    }
  },
  mounted() {
    this.rawMatName = this.$store.getters.getRawMatFamily;
    if (this.validateRawMatName(this.rawMatName)) {
      axios
        .get(RUTA_SERVIDOR + "api/sheet/list", {
          params: {
            sheet_raw_material: this.rawMatId,
          },
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        // .then((res) => (console.log(res.data)))
        .then((res) => {
          // Aquí colocas el código para eliminar los valores repetidos
          const uniqueSheets = new Set();
          res.data.forEach((availableSheet) => {
            // Reemplazar "/" por "-"
            //const specificationText = availableSheet.specification.replace(/\//g, "-");
            const sheetText = `${availableSheet.presentation} / ${availableSheet.specification}`;
            uniqueSheets.add(sheetText);
          });
          this.availableSheets = Array.from(uniqueSheets);

          // Continúas con la asignación de los datos a la propiedad availableSheets
          // this.availableSheets = res.data;
        })
        .catch((err) => console.log(`There has been an error ${err}`));
    } else {
      console.log("Nombre de familia no válido");
    }
  },
};
</script>
<style scoped>
.card {
  border: solid 2px #a6323b;
}

input [type="number"] {
  padding: 2px 6px 2px 16px;
  border: solid 5px #999999;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}

.avilable-input {
  background-color: #FCE196;
}
</style>